import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import CONFIG from '../../app-configs'
import { type CellOwnerAgreementPayload } from '../../api-schema-types/asset-holdings/CellOwnerAgreementPayloadDtos'
import { ApiAuthStrategies } from '../shared/ApiAuthStrategies'

export const cellOwnerAgreementsApi = createApi({
  reducerPath: 'cellOwnerAgreementsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${CONFIG.PROXIMA_BACK_END_V2_BASE_API_URL}/asset-holdings/asset-holders`,
    prepareHeaders: (headers: Headers, { getState }) => {
      const authToken = ApiAuthStrategies.getBearerTokenHeader()
      headers.set('authorization', authToken)
      return headers
    }
  }),
  endpoints: (builder) => ({
    create: builder.mutation<CellOwnerAgreementPayload, Partial<CellOwnerAgreementPayload>>({
      query: ({ ...patch }) => ({
        url: 'cell-owner-agreements/create',
        method: 'POST',
        body: patch
      })
    }),
    delete: builder.mutation<CellOwnerAgreementPayload, Partial<CellOwnerAgreementPayload>>({
      query: ({ ...patch }) => ({
        url: 'cell-owner-agreements/delete',
        method: 'POST',
        body: patch
      })
    }),
    createPdf: builder.mutation<CellOwnerAgreementPayload, Partial<CellOwnerAgreementPayload>>({
      query: ({ ...patch }) => ({
        url: 'cell-owner-agreements/create-pdf',
        method: 'POST',
        body: patch
      })
    }),
    deletePdf: builder.mutation<CellOwnerAgreementPayload, Partial<CellOwnerAgreementPayload>>({
      query: ({ ...patch }) => ({
        url: 'cell-owner-agreements/delete-pdf',
        method: 'POST',
        body: patch
      })
    }),

    getForMember: builder.query({
      query: ({ assetHolderId }) => ({
        url: `${assetHolderId}/cell-owner-agreements/all`,
        params: { }
      })
    }),

    getPdfUrl: builder.query({
      query: ({ assetHolderId, projectId }) => ({
        url: `${assetHolderId}/cell-owner-agreements/project/${projectId}/pdf-url`,
        params: { }
      })
    })
  })
})

export const useCellOwnerAgreementsApiCreateMutation = cellOwnerAgreementsApi.endpoints.create.useMutation
export const useCellOwnerAgreementsApiDeleteMutation = cellOwnerAgreementsApi.endpoints.delete.useMutation
export const useCellOwnerAgreementsApiCreatePdfMutation = cellOwnerAgreementsApi.endpoints.createPdf.useMutation
export const useCellOwnerAgreementsApiDeletePdfMutation = cellOwnerAgreementsApi.endpoints.deletePdf.useMutation

export const useCellOwnerAgreementsGetForMemberQuery = cellOwnerAgreementsApi.endpoints.getForMember.useQuery
export const useCellOwnerAgreementsGetPdfUrlLazyQuery = cellOwnerAgreementsApi.endpoints.getPdfUrl.useLazyQuery
